import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const DeleteSlotSlice = createSlice({
  name: "DeleteSlot",
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deleteSlot: (state, _) => {
      state.isLoading = true;
    },
    successDeleteSlot: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeleteSlot: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeleteSlot: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteSlot,
  failureDeleteSlot,
  successDeleteSlot,
  clearDeleteSlot,
} = DeleteSlotSlice.actions;

export default DeleteSlotSlice.reducer;
